"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.regexp.test.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicMultiSelectField = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _states = _interopRequireDefault(require("../../common/states"));
var _FormControls = require("../../go/components/common/FormControls");
var _DeprecatedDynamicComponent = _interopRequireDefault(require("../../go/components/dynamic/DeprecatedDynamicComponent"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DynamicMultiSelectField = /*#__PURE__*/function (_DynamicComponent) {
  _inherits(DynamicMultiSelectField, _DynamicComponent);
  var _super = _createSuper(DynamicMultiSelectField);
  function DynamicMultiSelectField(_props) {
    var _this$state;
    var _this;
    _classCallCheck(this, DynamicMultiSelectField);
    _this = _super.call(this, _props);
    _this.getDependencyData = function (dataPath) {
      var dependencyData = _lodash.default.get(_this.props.dynamicComponent, dataPath);
      // Use excludeOptions to control the data that is used for options creation from dependency data.
      // For example, get the Organizations dependency data but only used ones that are not manually added.
      if (!_lodash.default.isEmpty(_this.props.excludeOptions)) {
        var excludeOptions = _lodash.default.isArray(_this.props.excludeOptions) ? _this.props.excludeOptions : [_this.props.excludeOptions];
        var keysToRemove = [];
        _lodash.default.each(dependencyData, function (data, dataKey) {
          _lodash.default.each(excludeOptions, function (opt) {
            if (_lodash.default.toLower(_lodash.default.get(data, opt.key, '')) === _lodash.default.toLower(opt.value)) {
              keysToRemove.push(dataKey);
            }
          });
        });
        if (!_lodash.default.isEmpty(keysToRemove)) {
          dependencyData = _lodash.default.omit(dependencyData, keysToRemove);
        }
      }
      return dependencyData;
    };
    _this.generateSelectOptions = function (props) {
      var defaultOptions = [{
        key: 'Yes',
        value: 'Yes',
        text: 'Yes'
      }, {
        key: 'No',
        value: 'No',
        text: 'No'
      }, {
        key: 'Not applicable',
        value: 'Not applicable',
        text: 'Not applicable'
      }];

      //user provides dependency path in config, data is stored
      //in dependency path
      var dependencyData = _this.getDependencyData(props.dependencies);

      //if references exists need to create appropriate referece list.
      //Can have either a reference or key, value, text.
      if (props.referenceDataPath) {
        var referenceData = _this.getDependencyData(props.referenceDataPath);
        if (referenceData !== undefined) {
          var referenceDataTransformed = _lodash.default.map(dependencyData, function (entry) {
            delete referenceData.loading;
            var text2 = _lodash.default.filter(referenceData, function (x) {
              return entry[props.referenceKey] === undefined ? Number(x.id) === Number(entry) : Number(x.id) === Number(entry[props.referenceKey]);
            });
            if (text2 && !_lodash.default.isEmpty(text2)) {
              return {
                key: text2[0].id,
                value: text2[0].id,
                text: text2[0].displayText
              };
            }
          });
          dependencyData = referenceDataTransformed;
        }
      } else if (props.arrayKey && props.arrayValue && props.arrayText) {
        dependencyData = _lodash.default.omit(dependencyData, 'loading');
        var dependencyDataTransformed = _lodash.default.map(dependencyData, function (entry) {
          var text = '';
          if (entry && _lodash.default.isArray(props.arrayText)) {
            _lodash.default.each(props.arrayText, function (f) {
              var part = _lodash.default.get(entry, f, f);
              text = _lodash.default.isUndefined(part) || _lodash.default.isNil(part) || _lodash.default.trim(part) === '' ? _lodash.default.trim(text, '-') : text + part;
            });
            text = _lodash.default.trim(text, ' -');
          } else {
            text = entry[props.arrayText];
          }
          return {
            key: entry[props.arrayKey],
            value: entry[props.arrayValue],
            text: text
          };
        });
        dependencyData = dependencyDataTransformed;
      }
      _this.options = dependencyData;
      if (props.options) {
        _this.options = Object.assign([], props.options);
      }
      if (_this.options === undefined) {
        _this.options = defaultOptions;
      }
      if (props.isStateSelect) {
        _this.options = _states.default;
      }
    };
    _this.setValue = function (value) {
      _this.setState(_defineProperty({}, _this.props.pathToBeUsed, value), _this.handleBlur);
    };
    _this.handleOpen = function (e, data) {
      _this.setState({
        isOpen: true
      });
    };
    _this.handleClose = function (e, data) {
      _this.setState({
        isOpen: false
      });
    };
    _this.handleChange = function (e, data) {
      if (_this.props.pathForObjectRef) {
        var objectRef = _lodash.default.get(_this.props.dynamicComponent, _this.props.pathForObjectRef, []);
        if (data.value.length > objectRef.length) {
          var newValueArray = _lodash.default.filter(data.value, function (valueSelected) {
            return !_lodash.default.find(objectRef, {
              key: valueSelected
            });
          });
          var tempArray = _toConsumableArray(objectRef);
          _lodash.default.forEach(newValueArray, function (newValue) {
            var findObj = _lodash.default.find(_this.options, {
              key: newValue
            });
            tempArray.push(findObj);
          });
          objectRef = tempArray;
        } else if (data.value.length < objectRef.length) {
          objectRef = _lodash.default.filter(objectRef, function (objRef) {
            return data.value.includes(objRef.key);
          });
        }
        _this.props.saveEntityData(_this.props.pathForObjectRef, _this.props.entityType, objectRef, _this.props.validationId || _this.props.entityDataPath);
      }
      !_this.props.readOnly && _this.setValue(data.value);
    };
    _this.handleBlur = function () {
      if (_this.props.entityDataPath !== undefined) {
        var entityType = _this.props.entityType;
        _this.props.saveEntityData(_this.props.entityDataPath, entityType, _this.state[_this.props.pathToBeUsed], _this.props.validationId || _this.props.entityDataPath);
      } else {
        _this.save();
      }
      _this.validateField(_this.props.pathToBeUsed);
    };
    _this.save = function () {
      !_this.props.readOnly && _this.updateData();
    };
    _this.updateData = function () {
      var value = _this.state[_this.props.dataPath];
      _this.props.saveData(_this.props.dataPath, value);
    };
    _this.render = function () {
      var _this$props = _this.props,
        guidance = _this$props.guidance,
        title = _this$props.title,
        optional = _this$props.optional,
        pathToBeUsed = _this$props.pathToBeUsed,
        isHidden = _this$props.isHidden,
        formOptions = _this$props.formOptions,
        size = _this$props.size,
        disabled = _this$props.disabled,
        validationErrors = _this$props.validationErrors,
        validationDirtyMap = _this$props.validationDirtyMap,
        id = _this$props.id,
        ariaLabelledBy = _this$props.ariaLabelledBy,
        search = _this$props.search,
        multiple = _this$props.multiple,
        readOnly = _this$props.readOnly,
        onSearchChange = _this$props.onSearchChange,
        loading = _this$props.loading,
        keepPreviousOptions = _this$props.keepPreviousOptions,
        placeholder = _this$props.placeholder;
      var validationErrorsArray = _lodash.default.isEmpty(validationErrors) || _lodash.default.isArray(validationErrors) ? validationErrors : [validationErrors];
      var firstError = _lodash.default.find(validationErrorsArray, function (err) {
        return !err.isValid;
      }) || false;
      var errorMessage = firstError ? firstError.message : false;
      var displayError = firstError && validationDirtyMap.dirty;
      if (isHidden) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
      }
      if (keepPreviousOptions && !_this.state.isOpen && _this.state[_this.props.pathToBeUsed]) {
        if (_lodash.default.isArray(_this.state[_this.props.pathToBeUsed])) {
          var inList = true;
          _lodash.default.forEach(_this.state[_this.props.pathToBeUsed], function (selected) {
            var optionFound = _lodash.default.find(_this.options, {
              value: selected
            });
            if (!optionFound) {
              inList = false;
            }
          });
          if (!inList) {
            _this.options = _lodash.default.map(_this.state[_this.props.pathToBeUsed], function (selected) {
              if (_this.props.pathForObjectRef) {
                var values = _lodash.default.get(_this.props.dynamicComponent, _this.props.pathForObjectRef, []);
                var obj = _lodash.default.find(values, {
                  value: selected
                });
                return obj;
              } else {
                return {
                  key: selected,
                  value: selected,
                  text: selected
                };
              }
            });
          }
        } else if (!_lodash.default.find(_this.options, {
          value: _this.state[_this.props.pathToBeUsed]
        })) {
          _this.options = [{
            key: _this.state[_this.props.pathToBeUsed],
            value: _this.state[_this.props.pathToBeUsed],
            text: _this.state[_this.props.pathToBeUsed]
          }];
        }
      }
      var value = _this.state[pathToBeUsed] || '';
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormControls.MultiSelect, {
        multiple: multiple,
        search: search,
        value: value,
        label: title,
        options: _this.options,
        size: size,
        name: pathToBeUsed,
        displayError: displayError,
        onChange: _this.handleChange,
        onBlur: _this.handleBlur,
        errorMessages: errorMessage,
        guidance: guidance,
        formOptions: formOptions,
        disabled: disabled,
        optional: optional,
        id: id || pathToBeUsed,
        "aria-labelledby": ariaLabelledBy || id,
        readOnly: readOnly,
        onSearchChange: onSearchChange,
        loading: loading,
        onOpen: _this.handleOpen,
        onClose: _this.handleClose,
        placeholder: placeholder
      }));
    };
    _this.generateSelectOptions(_props);
    _this.state = (_this$state = {}, _defineProperty(_this$state, _props.pathToBeUsed, _props.value ? _props.value : undefined), _defineProperty(_this$state, "isOpen", false), _this$state);
    return _this;
  }
  _createClass(DynamicMultiSelectField, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.refreshData(prevProps);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.refreshData();
    }
  }, {
    key: "refreshData",
    value: function refreshData(prevProps) {
      var _this$props2 = this.props,
        isHidden = _this$props2.isHidden,
        pathToBeUsed = _this$props2.pathToBeUsed,
        data = _this$props2.data,
        clearEntityData = _this$props2.clearEntityData,
        validationId = _this$props2.validationId,
        entityDataPath = _this$props2.entityDataPath,
        entityType = _this$props2.entityType;
      if (!isHidden && !_lodash.default.get(prevProps, 'isHidden') && !_lodash.default.isEqual(data, _lodash.default.get(prevProps, 'data'))) {
        this.setState(_defineProperty({}, pathToBeUsed, data));
      } else if (isHidden && this.state[pathToBeUsed] !== undefined) {
        this.setState(_defineProperty({}, pathToBeUsed, undefined), function () {
          return clearEntityData(entityDataPath, entityType, validationId);
        });
      }
      this.generateSelectOptions(this.props);
    }
  }]);
  return DynamicMultiSelectField;
}(_DeprecatedDynamicComponent.default);
exports.DynamicMultiSelectField = DynamicMultiSelectField;